import { RadioButton as BaseRadioButton } from "@moneyforward/mfx_biz_react_components";
import React from "react";
import { get, RegisterOptions, useFormContext } from "react-hook-form";

interface FormRadioButtonProps {
  name: string;
  value: string;
  label: string;
  registerOptions?: RegisterOptions;
  bgSize?: "sm" | "md";
}

const InnerFormRadioButton = (
  { name, value, label, bgSize = "sm", registerOptions }: FormRadioButtonProps,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const { watch, register, setValue, formState } = useFormContext();

  const formValue = watch(name);
  const onClick = () => {
    setValue(name, value, { shouldValidate: true });
  };

  return (
    <BaseRadioButton
      {...register(name, registerOptions)}
      checked={formValue === value}
      label={label}
      bgSize={bgSize}
      ref={ref}
      value={value}
      isError={!!get(formState.errors, name)}
      onClick={onClick}
    />
  );
};
export const FormRadioButton = React.forwardRef(InnerFormRadioButton);
